import { Flex, Image, Text } from '@podiumhq/design-system';
import googleLogo from '../../assets/google.svg';
import GoogleStars from '../GoogleStars';

const GoogleRating = () => (
  <Flex w="60%" justifyContent="flex-end">
    <Flex
      p="16px"
      borderRadius="24px"
      bg="silver.lightest"
      borderBottomLeftRadius="0px"
      w="210px"
      flexDir="column"
    >
      <Flex w="100%" justifyContent="space-between" alignItems="center">
        <Text fontWeight="semibold" fontSize="md" color="black.base">
          Google Rating
        </Text>
        <Image w="25px" alt="Google logo" src={googleLogo} />
      </Flex>
      <Flex w="100%" alignItems="center" pt="10px">
        <Text fontWeight="semibold" fontSize="lg" color="black.base" mr="8px">
          4.8
        </Text>
        <GoogleStars />
      </Flex>
    </Flex>
  </Flex>
);

export default GoogleRating;
